<template>
    <validation-observer ref="declaration">
        <b-row v-if="compactView">
            <b-col>
                <b-card bg-variant="default" border-variant="light">
                    <b-row>
                        <b-col>
                            <b-form-group :label="$t('Component(Verification):legislations-covered')">
                                <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Component(Verification):legislations-covered')"
                                    rules="required"
                                >
                                    <v-select
                                        multiple
                                        v-model="declaration.legislations"
                                        :placeholder="$t('Component(Composition):placeholder-legislations')"
                                        :options="legislations"
                                        :getOptionLabel="(o) => o.title"
                                        @input="onChange"
                                        :state="errors.length > 0 ? false:null"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" lg="6">
                            <b-form-group :label="$t('Component(Verification):declaration-date')">
                                <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Component(Verification):declaration-date')"
                                    rules="required"
                                >
                                    <b-form-datepicker
                                        v-model="declaration.declarationDate"
                                        :date-format-options="$store.state.component.datePicker.format"
                                        @input="onChange"
                                        placeholder=""
                                        :state="errors.length > 0 ? false:null"
                                        :locale="$store.state.component.datePicker.locale"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" lg="6">
                            <b-form-group :label="$t('Component(Verification):validity-of-declaration')">
                                <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Component(Verification):validity-of-declaration')"
                                    rules="required"
                                >
                                    <b-form-datepicker
                                        v-model="declaration.declarationValidityDate"
                                        :date-format-options="$store.state.component.datePicker.format"
                                        @input="onChange"
                                        placeholder=""
                                        :state="errors.length > 0 ? false:null"
                                        :locale="$store.state.component.datePicker.locale"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group :label="declaration.file.name ? $t('Component(File):uploaded-file') : $t('Component(File):upload-file')">
                                <div v-if="!isInputVisible">
                                    <span class="d-flex">{{ declaration.file.name }}</span>
                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        variant="secondary"
                                        class="mt-0 mr-0 float-right"
                                        @click="reUpload"
                                    >
                                        {{ $t('Component(Button):re-upload') }}
                                    </b-button>
                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        variant="primary"
                                        class="mt-0 mr-1 sm float-right"
                                        @click="download"
                                        :disabled="downloading"
                                    >
                                        <b-spinner v-if="downloading" small />
                                        <feather-icon
                                            v-if="!downloading"
                                            icon="DownloadCloudIcon"
                                        />
                                    </b-button>
                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        variant="primary"
                                        class="mt-0 mr-1 sm float-right"
                                        @click="preview"
                                    >
                                        <feather-icon
                                            icon="EyeIcon"
                                        />
                                    </b-button>
                                </div>
                                <div v-if="isInputVisible" >
                                    <b-form-file
                                        v-model="declaration.document"
                                        :placeholder="$t('Component(Placeholder):choose-file-or-drop')"
                                        drop-placeholder="Drop file here..."
                                        accept="application/pdf,application/x-pdf"
                                        :class="{'w-75': declaration.id}"
                                        @input="onChange"
                                    />
                                    <div class="cancel-button-container" v-if="declaration.id">
                                        <b-button
                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="secondary"
                                            class="mt-0 mr-0 sm float-right"
                                            @click="cancel"
                                        >
                                            {{ $t('Component(Button):cancel') }}
                                        </b-button>
                                    </div>

                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col md="3" lg="4">
                <b-form-group :label="$t('Component(Verification):legislations-covered')">
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Component(Verification):legislations-covered')"
                        rules="required"
                    >
                        <v-select
                            multiple
                            v-model="declaration.legislations"
                            :placeholder="$t('Component(Composition):placeholder-legislations')"
                            :options="legislations"
                            :getOptionLabel="(o) => o.title"
                            @input="onChange"
                            :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2">
                <b-form-group :label="$t('Component(Verification):declaration-date')">
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Component(Verification):declaration-date')"
                        rules="required"
                    >
                        <b-form-datepicker
                            v-model="declaration.declarationDate"
                            :date-format-options="$store.state.component.datePicker.format"
                            :locale="$store.state.component.datePicker.locale"
                            @input="onChange"
                            placeholder=""
                            :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2">
                <b-form-group :label="$t('Component(Verification):validity-of-declaration')">
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Component(Verification):validity-of-declaration')"
                        rules="required"
                    >
                        <b-form-datepicker
                            v-model="declaration.declarationValidityDate"
                            :date-format-options="$store.state.component.datePicker.format"
                            :locale="$store.state.component.datePicker.locale"
                            placeholder=""
                            @input="onChange"
                            :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="4">
                <b-form-group :label="declaration.file.name ? $t('Component(File):uploaded-file') : $t('Component(File):upload-file')">
                    <div v-if="!isInputVisible">
                        <div style="max-width: 158px !important; display: inline-block">{{ declaration.file.name }}</div>
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="secondary"
                            class="mt-0 mr-0 float-right"
                            @click="reUpload"
                        >
                            {{ $t('Component(Button):re-upload') }}
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mt-0 mr-1 sm float-right"
                            @click="download"
                            :disabled="downloading"
                        >
                            <b-spinner v-if="downloading" small />
                            <feather-icon
                                v-if="!downloading"
                                icon="DownloadCloudIcon"
                            />
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mt-0 mr-1 sm float-right"
                            @click="preview"
                        >
                            <feather-icon
                                icon="EyeIcon"
                            />
                        </b-button>
                    </div>
                    <div v-if="isInputVisible" >
                        <b-form-file
                            v-model="declaration.document"
                            :placeholder="$t('Component(Placeholder):choose-file-or-drop')"
                            drop-placeholder="Drop file here..."
                            :class="{'w-75': declaration.id}"
                            accept="application/pdf,application/x-pdf"
                            @input="onChange"
                        />

                        <div class="cancel-button-container" v-if="declaration.id">
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="secondary"
                                class="mt-0 mr-0 sm float-right"
                                @click="cancel"
                            >
                                {{ $t('Component(Button):cancel') }}
                            </b-button>
                        </div>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </validation-observer>
</template>
<script>
import { BSpinner, BFormGroup, BFormDatepicker, BCard, BCardTitle, BRow, BCol, BFormFile, BButton } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {required} from '@validations'

export default {
    components: {
        BCard, ValidationProvider, ValidationObserver,
        BCardTitle,
        BRow,
        BCol,
        BButton,
        BFormGroup,
        BFormDatepicker,
        vSelect,
        BFormFile,
        BSpinner,
    },
    directives: {
        Ripple
    },
    props: {
        compactView: {
            type: Boolean,
            default: false,
        },
        legislations: {
            type: Array,
            default() {
                return [];
            }
        },
        declaration: {
            type: Object,
            default() {
                return {
                    id: null,
                    selectedLegislations: [],
                    declarationDate: null,
                    declarationValidityDate: null,
                    document: null,
                    file: {
                        name: ''
                    }
                };
            }
        }
    },
    data() {
        return {
            downloading: false,
            showFileInput: !this.declaration.id,
            required
        };
    },
    methods: {
        onChange() {
            this.$nextTick(() => {
                this.$refs.declaration.validate().then(valid => {
                    if (valid && (this.declaration.document || this.declaration.id)) {
                        this.$emit('change', this.declaration);
                    }
                });
            });
        },
        reUpload() {
            this.showFileInput = true;
        },
        download() {
            this.downloading = true;
            this.$emit('download', this.declaration, () => {
                this.downloading = false;
            });
        },
        preview() {
            this.$emit('preview', this.declaration);
        },
        cancel() {
            this.showFileInput = false;
            this.declaration.document = null;
            this.$emit('change', this.declaration);
        }
    },
    computed: {
        isInputVisible() {
            if (this.declaration.id && this.showFileInput) {
                return true;
            }
            return !this.declaration.id;
        }
    },
    watch: {
        declaration(value) {
            if (value.id && !value.document) {
                this.showFileInput = false;
            }
        }
    }
}
</script>
<style>
.cancel-button-container {
    display: inline;
    position: relative;
}
</style>
